  <template>
    <div v-if="model">
        <div class="row">
        <div class="col-sm-12 col-md-4 col-xl-4">
            <div class="container-title">
            {{ $t('sale_notes.shows.sale_note_detail') }}
            </div>
            <b-card no-body v-bind="cardAttrs">
            <b-card-body>
                <b-card-text class="custom-group">
                <div class="custom-label">{{ $t('sale_notes.shows.sales_id')}}</div>
                  <span class="custom-text">{{ model.type_name }}-{{ model.id }}</span>
                </b-card-text>
                <b-card-text class="custom-group">
                <div class="custom-label">{{ $t('sale_notes.shows.folder_id')}}</div>
                <span class="custom-text">
                <a :href="`/tickets/${model.ticket_id}`">{{ model.ticket_id }}</a>
                </span>
                </b-card-text>
                <b-card-text class="custom-group">
                <div class="custom-label">{{ $t('sale_notes.shows.harvest_note_id')}}</div>
                <span class="custom-text">
                <template v-if="purchaseOrderIds.length">
                    <span v-for="(id, index) in purchaseOrderIds" class="custom-text" v-bind:key="id">
                    <a :href="`/purchase_orders/${id}`">{{ id }}</a><template v-if="index < purchaseOrderIds.length - 1">, </template>
                    </span>
                </template>
                <template v-else>-</template>
            </span>
                </b-card-text>
                <b-card-text class="custom-group">
                <div class="custom-label">{{ $t('sale_notes.shows.seller')}}</div>
                <span class="custom-text">
                <template v-if="sellerNames.length">
                    <span v-for="(name, index) in sellerNames" class="custom-text" v-bind:key="name">
                    {{ name }}<template v-if="index < sellerNames.length - 1">, </template>
                    </span>
                </template>
                <template v-else>-</template>
                </span>
                </b-card-text>
                <b-card-text class="custom-group">
                <div class="custom-label">{{ $t('sale_notes.shows.buyer')}}</div>
                <template v-if="buyerNames.length">
                <span v-for="(name, index) in buyerNames" class="custom-text" v-bind:key="name">
                    {{ name }}<template v-if="index < buyerNames.length - 1">, </template>
                </span>
                </template>
                <template v-else>-</template>
                </b-card-text>
                <b-card-text class="custom-group">
                  <div class="custom-label">{{ $t('products.singular') }}</div>
                <span class="custom-text">
                <template v-if="serviceNames.length">
                    <span v-for="(name, index) in serviceNames" class="custom-text" v-bind:key="name">
                    {{ name }}<template v-if="index < serviceNames.length - 1">, </template>
                    </span>
                </template>
                <template v-else>-</template>
                </span>
                </b-card-text>
            </b-card-body>
            </b-card>
        </div>
        <div class="col-sm-12 col-md-8 col-xl-8">
            <div class="container-title">
            {{ $t('sale_notes.shows.sales_detail') }}
            </div>
            <b-card no-body v-bind="cardAttrs">
            <b-card-body style="padding: 0">
                <div class="section-title">
                {{ $t('sale_notes.shows.revenue') }}
                </div>
                <div class="section-body">
                <div class="section-row row">
                    <div class="col-6 section-label ">{{
                        `${lodash.startCase($t('sale_notes.revenue_jala_harvest'))} (${$numeral(saleOrderTotalBiomass).
                            format('0,0.[000]')} kg):`
                    }}</div>
                    <div class="col-6 section-value pull-right">{{
                        $numeral(harvestSalesTotal).format('$ 0,0.[000]')
                    }}</div>
                </div>
                <div class="section-row row">
                    <div class="col-6 section-label ">
                    {{ `${lodash.startCase($t('sale_notes.shows.discount'))}` }}
                    <b-button :class="revenueDiscountVisible ? null : 'collapsed'" :aria-expanded="revenueDiscountVisible ? 'true' : 'false'" aria-controls="collapse-revenue-discount" @click="revenueDiscountVisible = !revenueDiscountVisible" style="padding: 0;" variant="link">
                        <i v-if="!revenueDiscountVisible" class="text-dark bx bxs-right-arrow"></i>
                        <i v-else class="text-dark bx bxs-down-arrow"></i>
                    </b-button>
                    </div>
                    <div class="col-6 section-value pull-right">{{
                        $numeral(Math.abs(revenueDiscountTotal)).format('$ 0,0.[000]')
                    }}</div>
                </div>
                <b-collapse id="collapse-revenue-discount" v-model="revenueDiscountVisible">
                    <div v-for="(revenueDiscount, index) in revenueDiscounts" v-bind:key="index" class="section-row row" style="padding-left: 10px">
                    <div class="col-6 section-label">
                        <template v-if="model.type === 'brs'">
                        {{ lodash.startCase($t(`sale_notes.shows.${lodash.lowerCase(revenueDiscount.sales_reportable.name)}`)) }}
                        </template>
                        <template v-else>
                        {{ lodash.startCase(revenueDiscount.sales_reportable.name) }}
                        </template>
                    </div>
                    <div class="col-6 section-value pull-right">{{ $numeral(Math.abs(revenueDiscount.total)).format('$ 0,0.[000]') }}</div>
                    </div>
                    <div class="section-row row" style="padding-left: 10px">
                    <div :class="{'col-6': true, 'section-value': true, 'text-success': revenueTotal > 0, 'text-danger': revenueTotal < 0}" style="text-align: left !important;">{{ `${lodash.startCase($t('sale_notes.shows.total_revenue'))}:` }}</div>
                    <div :class="{'col-6': true, 'section-value': true, 'text-success': revenueTotal > 0, 'text-danger': revenueTotal < 0}">{{
                        $numeral(revenueTotal).format('$ 0,0.[000]')
                        }}</div>
                    </div>
                </b-collapse>
                </div>
                <div class="section-title">
                <div class="d-flex justify-content-between">
                    {{ $t('sale_notes.shows.COGS') }}
                    <b-button :class="cogsVisible ? null : 'collapsed'" :aria-expanded="cogsVisible ? 'true' : 'false'" aria-controls="collapse-cogs" @click="cogsVisible = !cogsVisible" style="padding: 0;" variant="link">
                    <i v-if="!cogsVisible" class="text-dark bx bxs-right-arrow"></i>
                    <i v-else class="text-dark bx bxs-down-arrow"></i>
                    </b-button>
                </div>
                </div>
                <b-collapse id="collapse-cogs" v-model="cogsVisible">
                <div class="section-body">
                    <div class="section-row row">
                    <div class="col-6 section-label ">{{ `${lodash.startCase($t(`sale_notes.shows.harvested_shrimp`))}:` }}</div>
                    <div class="col-6 section-value pull-right">{{
                        $numeral(harvestShrimpTotal).format('$ 0,0.[000]')
                        }}</div>
                    </div>
                    <div v-if="glazingTotal > 0" class="section-row row">
                    <div class="col-6 section-label ">{{ `${lodash.startCase($t(`sale_notes.shows.glazing/ice`))}:` }}</div>
                    <div class="col-6 section-value pull-right">{{
                        $numeral(glazingTotal).format('$ 0,0.[000]')
                        }}</div>
                    </div>
                    <div class="section-row row">
                    <div
                        :class="{
                        'col-6': true,
                        'section-value': true,
                        'text-success': model.total_cost_of_goods_sold > 0,
                        'text-danger': model.total_cost_of_goods_sold < 0
                        }"
                        style="text-align: left!important;"
                    >
                        {{ `${lodash.startCase($t('sale_notes.shows.total_COGS'))}:` }}
                    </div>
                    <div class="col-6 section-value pull-right text-success">{{ $numeral(model.total_cost_of_goods_sold).format('$ 0,0.[000]') }}</div>
                    </div>
                </div>
                </b-collapse>
                <div class="section-title">
                {{ $t('sale_notes.shows.gross_profit') }}
                </div>
                <div class="section-body">
                <div class="section-row row">
                    <div class="col-6 section-label ">{{ `${lodash.startCase($t('sale_notes.shows.gross_profit'))}:` }}</div>
                    <div class="col-6 section-value pull-right">{{ $numeral(model.gross_profit).format('$ 0,0.[000]') }}</div>
                </div>
                <div class="section-row row">
                    <div :class="{'col-6': true, 'section-value': true, 'text-success': grossProfitMargin > 0, 'text-danger': grossProfitMargin < 0}" style="text-align: left!important;">{{ `${lodash.startCase($t('sale_notes.shows.GPM'))}:` }}</div>
                    <div :class="{'col-6': true, 'section-value': true, 'text-success': grossProfitMargin > 0, 'text-danger': grossProfitMargin < 0}">{{ $numeral(grossProfitMargin).format('0,0.[000]%') }}</div>
                </div>
                </div>
                <div class="section-title">
                <div class="d-flex justify-content-between">
                    {{ $t('sale_notes.shows.expense') }}
                    <b-button :class="expenseVisible ? null : 'collapsed'" :aria-expanded="expenseVisible ? 'true' : 'false'" aria-controls="collapse-discount-partner" @click="expenseVisible = !expenseVisible" style="padding: 0;" variant="link">
                    <i v-if="!expenseVisible" class="text-dark bx bxs-right-arrow"></i>
                    <i v-else class="text-dark bx bxs-down-arrow"></i>
                    </b-button>
                </div>
                </div>
                <b-collapse id="collapse-expense" v-model="expenseVisible">
                <div class="section-body">
                    <div class="section-row row">
                    <div class="col-6 section-label ">{{ `${lodash.startCase($t('sale_notes.shows.shipping_cost'))}:` }}</div>
                    <div class="col-6 section-value pull-right">{{ $numeral(shippingCostTotal).format('$ 0,0.[000]') }}</div>
                    </div>
                    <div class="section-row row">
                    <div class="col-6 section-label ">{{ `${lodash.startCase($t('sale_notes.shows.labour_cost'))}:` }}</div>
                    <div class="col-6 section-value pull-right">{{ $numeral(labourCostTotal).format('$ 0,0.[000]') }}</div>
                    </div>
                  <div v-if="otherExpenseTotal > 0" class="section-row row">
                    <div class="col-6 section-label ">{{ `${lodash.startCase($t('sale_notes.shows.other_expense'))}:` }}</div>
                    <div class="col-6 section-value pull-right">{{ $numeral(otherExpenseTotal ).format('$ 0,0.[000]') }}</div>
                  </div>
                  <div v-if="totalOtherExpenseByJala > 0" class="section-row row">
                    <div class="col-6 section-label ">{{ `${lodash.startCase($t('sale_notes.shows.unloading_cost_by_jala'))}:` }}</div>
                    <div class="col-6 section-value pull-right">{{ $numeral(totalOtherExpenseByJala).format('$ 0,0.[000]') }}</div>
                  </div>
                  <div v-if="totalOtherExpenseByPartner > 0" class="section-row row">
                    <div class="col-6 section-label ">{{ `${lodash.startCase($t('sale_notes.shows.unloading_cost_by_partner'))}:` }}</div>
                    <div class="col-6 section-value pull-right">{{ $numeral(totalOtherExpenseByPartner).format('$ 0,0.[000]') }}</div>
                  </div>
                    <div class="section-row row">
                    <div class="col-6 section-value" style="text-align: left">{{ `${lodash.startCase($t('sale_notes.shows.general_affairs_cost'))}` }}</div>
                    </div>
                    <div class="section-row row">
                    <div class="col-6 section-label ">{{ `${lodash.startCase($t('sale_notes.shows.acceleration'))}:` }}</div>
                    <div class="col-6 section-value pull-right">{{ $numeral(accelerationTotal).format('$ 0,0.[000]') }}</div>
                    </div>
                    <div class="section-row row">
                    <div class="col-6 section-label ">{{ `${lodash.startCase($t('sale_notes.shows.PPh_22_out'))}:` }}</div>
                    <div class="col-6 section-value pull-right">{{ $numeral(pphTotal).format('$ 0,0.[000]') }}</div>
                    </div>
                    <div v-if="!(isJalaHarvest)" class="section-row row">
                    <div class="col-6 section-label ">{{ `${lodash.startCase($t('sale_notes.shows.profit_share'))}:` }}</div>
                    <div class="col-6 section-value pull-right">{{ $numeral(profitShareTotal).format('$ 0,0.[000]') }}</div>
                    </div>
                </div>
                </b-collapse>
<!--                <div class="section-title">-->
<!--                    <div class="d-flex justify-content-between">-->
<!--                        {{ $t('sale_notes.shows.EBITDA') }}-->
<!--                        <b-button :class="ebitdaVisible ? null : 'collapsed'" :aria-expanded="ebitdaVisible ? 'true' : 'false'" aria-controls="collapse-cogs" @click="ebitdaVisible = !ebitdaVisible" style="padding: 0;" variant="link">-->
<!--                            <i v-if="!ebitdaVisible" class="text-dark bx bxs-right-arrow"></i>-->
<!--                            <i v-else class="text-dark bx bxs-down-arrow"></i>-->
<!--                        </b-button>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <b-collapse id="collapse-ebitda" v-model="ebitdaVisible">-->
<!--                    <div class="section-body">-->
<!--                        <div class="section-row row">-->
<!--                            <div class="col-6 section-label ">{{ `${lodash.startCase($t(`sale_notes.shows.EBITDA`))}:` }}</div>-->
<!--                            <div class="col-6 section-value pull-right">{{-->
<!--                                    $numeral(ebitda).format('$ 0,0.[000]')-->
<!--                                }}</div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </b-collapse>-->
                <div class="section-title">
                {{ $t(`sale_notes.shows.${isJalaHarvest ? 'margin' : 'profit'}`) }}
                </div>
                <div class="section-body">
                <div class="section-row row">
                    <div class="col-6 section-label ">{{ `${lodash.startCase($t(`sale_notes.shows.total_${isJalaHarvest ? 'margin' : 'profit'}_before_acceleration`))}:` }}</div>
                    <div class="col-6 section-value pull-right">{{ $numeral(profitBeforeAccelerationTotal).format('$ 0,0.[000]') }}</div>
                </div>
                <div class="section-row row">
                    <div class="col-6 section-label ">{{ `${lodash.startCase($t(`sale_notes.shows.total_${isJalaHarvest ? 'margin' : 'profit'}`))}:` }}</div>
                    <div class="col-6 section-value pull-right">{{ $numeral(model.total_profit).format('$ 0,0.[000]') }}</div>
                </div>
                <div class="section-row row">
                    <div :class="{'col-6': true, 'section-value': true, 'text-success': netProfitMargin > 0, 'text-danger': netProfitMargin < 0}" style="text-align: left!important;">{{ `${lodash.startCase($t('sale_notes.shows.NPM'))}:` }}</div>
                    <div :class="{'col-6': true, 'section-value': true, 'text-success': netProfitMargin > 0, 'text-danger': netProfitMargin < 0}">{{ $numeral(netProfitMargin).format('0,0.[000]%') }}</div>
                </div>
                </div>
            </b-card-body>
            </b-card>
        </div>
        <div class="col-12">
            <div class="container-title">
            {{ $t('sale_notes.shows.sale_note_items') }}
            </div>
            <b-card no-body style="margin-bottom: 0">
            <b-table-simple responsive hover style="margin: 0; border-radius: 8px">
                <colgroup><col><col><col><col><col></colgroup>
                <b-thead class="sale-item-thead">
                <b-tr>
                    <b-th>{{ $t('sale_note_items.no') }}</b-th>
                    <b-th>{{ $t('sale_note_items.quality') }}</b-th>
                    <b-th>{{ $t('sale_note_items.size') }}</b-th>
                    <b-th>{{ `${$t('sale_note_items.quantity')} (${$t('units.kg')})` }}</b-th>
                    <b-th>{{ $t('sale_note_items.unit_price') }}</b-th>
                    <b-th>{{ $t('sale_note_items.total_price') }}</b-th>
                </b-tr>
                </b-thead>
                <b-tbody class="sale-item-tbody">
                <b-tr v-for="(item, index) in model.sale_items" v-bind:key="index">
                    <b-td>{{ index + 1 }}</b-td>
                    <b-td>{{ item.quality ? lodash.upperFirst($t(`sale_note_items.qualities.${item.quality}`)) : '-' }}</b-td>
                    <b-td>{{ decimalFormatter(item.size) }}</b-td>
                    <b-td>{{ decimalFormatter(item.quantity) }}</b-td>
                    <b-td>{{ $numeral(item.unit_price).format('$ 0,0.[000]') }}</b-td>
                    <b-td>{{ $numeral(item.total_price).format('$ 0,0.[000]') }}</b-td>
                </b-tr>
                </b-tbody>
            </b-table-simple>
            </b-card>
        </div>
        <div class="col-12" style="margin: 8px 0">
            <span>{{ lodash.startCase($t('CreatedBy')) }}: {{ creatorName }} - {{ $moment.utc(model.created_at).local().format('DD MMM YYYY hh:mm:ss') }}</span>
        </div>
        </div>
    </div>
  </template>
  <script>
  //   import Loader from '@/components/widgets/loader';
  import ModelShow from '../../models/show';
  import Row from '@/components/models/show/custom-row';

  export default {
    extends: ModelShow,
    page: {
      title: "Detail Sale Notes",
    },
    components: {
    //   Loader,
    },
    props: {
      cardTitle: {default() { return this.lodash.startCase(this.$t('sale_notes.singular')) }},
      resourceRoute: {default: 'sale_notes'},
      modelVariable: {default: 'sale_note'},
      denyDelete: {type: Boolean, default: true},
      denyEdit: {type: Boolean, default() {return !this.$auth.hasJalaTradeRole(['admin', 'finances'])}},
      columns: {
        type: Object,
        default() {
          return {
            [this.  modelVariable || 'model']: [
              {
                key: 'key',
                label: this.$t('models.key'),
                component: Row
              }
            ]
          };
        }
      },
      cardAttrs: {
        default() {
          return {
            class: 'card-plain',
            style: {marginBottom: 0, padding: 0, overflow: 'hidden', height: '491px', overflowY: 'auto'},
            noBody: true,
            'data-simplebar': true,
            'data-simplebar-auto-hide': "false"
          }
        }
      },
      value: { type: Object, default: function () {return {}} },
    },
    watch: {
      model: function (val, oldVal) {
        if (!this.lodash.isEqual(val, oldVal)) {
          if (val.ticketable.ticket.customer_type !== 'brs') this.denyEdit = true
        }
      },
    },
    data() {
      return {
        title: this.lodash.startCase(this.$t('sale_notes.plural')),
        discountsPartnerVisible: false,
        revenueDiscountVisible: true,
        cogsVisible: true,
        expenseVisible: true,
        ebitdaVisible: true,
      }
    },
    mounted() {
      this.setModel();
    },
    computed: {
      isKmService () {
        return this.model?.trip?.type === 'deposit_goods'
      },
      isJalaHarvest() {
        return this.model?.trip?.trip_items?.[0]?.purchase_item?.purchase_order?.type === 'harvest'
      },
      ebitda(){
        return this.model.total_profit + this.pphTotal;
      },
      accelerationTotal() {
        let reports = this.model?.sales_reports?.filter(({ category, sales_reportable }) => category === 'expense' && sales_reportable?.name?.toLowerCase() === 'biaya percepatan')
        return Math.abs(reports?.reduce((carry, { total }) => carry + (total ?? 0), 0))
      },
      buyerNames() {
        let names = []

        if (this.model.type === 'brs' && this.model.buyer_name) {
          names.push(this.model.buyer_name)
        } else if (this.model.is_unload_order && this.model?.customer?.name) {
          names.push(this.model?.customer?.name)
        } else if (this.model.type === 'local_market') {
          this.model?.sale_items?.forEach(saleItem => {
            if (saleItem?.buyer) {
              names.push(saleItem?.buyer)
            }
          })
        }

        return [ ...new Set(names) ].sort()
      },
      creatorName() {
        return this.model?.creator?.name ?? '-'
      },
      otherExpenses() {
        return this.model?.sales_reports?.filter(({ category, sub_category }) => category === 'expense' && sub_category === 'other')
      },
      otherExpenseByJala() {
        return this.model?.sales_reports?.filter(({ category, sub_category }) => category === 'expense' && sub_category === 'paid_by_jala')
      },
      otherExpenseByPartner() {
        return this.model?.sales_reports?.filter(({ category, sub_category }) => category === 'expense' && sub_category === 'paid_by_partner')
      },
      totalOtherExpenseByJala() {
        return -this.otherExpenseByJala?.filter(({ sales_reportable }) => sales_reportable?.name?.toLowerCase() !== 'pph 22').reduce((carry, { total }) => carry + (total || 0), 0)
      },
      totalOtherExpenseByPartner() {
        return -this.otherExpenseByPartner?.reduce((carry, { total }) => carry + (total || 0), 0)
      },
      otherExpenseTotal() {
        return -this.otherExpenses?.reduce((carry, { total }) => carry + (total || 0), 0)
      },
      expenses() {
        return this.model?.sales_reports?.filter(({category}) => category === 'expense') || []
      },
      glazingTotal() {
        return Math.abs(this.model?.sales_reports?.filter(({category, sub_category}) => category === 'cost_of_goods_sold' && sub_category === 'ice').reduce((carry, { total }) => carry + (total ?? 0), 0))
      },
      grossProfitMargin() {
        return this.model.gross_profit / this.model.total_revenue
      },
      grossProfitTotal() {
        return this.model?.gross_profit ?? 0
      },
      harvestSales() {
        return this.model?.sales_reports?.filter(({ category, sub_category }) => category === 'revenue' && sub_category === 'harvest')
      },
      harvestSalesTotal() {
        return this.harvestSales?.reduce((carry, { total }) => carry + (total ?? 0), 0) ?? 0
      },
      harvestShrimpTotal() {
        return Math.abs(this.model?.sales_reports?.filter(({category, sub_category}) => category === 'cost_of_goods_sold' && sub_category === 'harvest').reduce((carry, { total }) => carry + (total ?? 0), 0))
      },
      labourCostTotal() {
        let reports = this.model?.sales_reports?.filter(({ category, sub_category }) => category === 'expense' && sub_category === 'labour')
        return Math.abs(reports?.reduce((carry, { total }) => carry + (total ?? 0), 0))
      },
      netProfitMargin() {
        return this.model.total_profit / this.model.total_revenue
      },
      pphTotal() {
        let reports = this.model?.sales_reports?.filter(({ category, sales_reportable }) => category === 'expense' && sales_reportable?.name?.toLowerCase() === 'pph 22')
        return Math.abs(reports?.reduce((carry, { total }) => carry + (total ?? 0), 0))
      },
      profitShareTotal() {
        return this.model.profit_share?.total ?? 0
      },
      profitBeforeAccelerationTotal() {
        let expenseTotal = -this.expenses.reduce((carry, { total }) => carry + (total || 0), 0)
        return this.grossProfitTotal - (expenseTotal - this.accelerationTotal)
      },
      profitTotal() {
        return this.model?.total_profit
      },
      purchaseOrderIds() {
        let ids = this.model
            ?.sale_items
            ?.map(({trip_items}) => trip_items
                .map(({purchase_item: {purchase_order_id}}) => purchase_order_id))
            .flat(1)
            .sort((a, b) => a - b)
        return [...new Set(ids)]
      },
      revenueDiscounts() {
        return this.model?.sales_reports?.filter(({category, sub_category, total}) => category === 'revenue' && sub_category === 'discount' && total !== 0)
      },
      revenueDiscountTotal() {
        return this.revenueDiscounts?.reduce((carry, {total}) => carry + (total ?? 0), 0)
      },
      revenueTotal() {
        return this.model?.total_revenue ?? 0
      },
      saleOrderTotalBiomass() {
        return this.model?.sale_item_total_quantity
      },
      saleOrderTotalInitialBiomass() {
        return this.model?.sale_item_total_initial_quantity
      },
      sellerNames() {
        let names = this.model
            ?.sale_items
            ?.map(({trip_items}) => trip_items
                .map(({purchase_order: {customer: {name}}}) => name))
            .flat(1)
        return [...new Set(names)].sort()
      },
      serviceNames() {
        let names = this.model
            ?.sale_items
            ?.map(({trip_items}) => trip_items
                .map(({purchase_order: {product: {name}}}) => name))
            .flat(1)
        return [...new Set(names)].sort()
      },
      shippingCostTotal() {
        let reports = this.model?.sales_reports?.filter(({ category, sub_category }) => category === 'expense' && sub_category === 'delivery')
        return Math.abs(reports?.reduce((carry, { total }) => carry + (total ?? 0), 0))
      },
      items() {
        return [
          {
            text: this.lodash.startCase(this.$t('sale_notes.plural')),
            href: "/sale_notes",
          },
          {
            text: this.model && this.model.id ? this.model['name'] : this.$route.params.key,
            href: `/sale_notes/${this.$route.params.key}`,
            active: true,
          }
        ]
      },
    },
    methods: {
      decimalFormatter(value) {
        return this.$numeral(value).format('0,0.[00]')
      },
      pills(){
        return [
          {
            label: 'Detail',
            active: (this.$route.name === 'sale_notes.show'),
            onClick: () => this.$router.push({ name: 'sale_notes.show', params: { key: this.$route.params.key } })
          },
          {
            label: 'Resume',
            active: (this.$route.name === 'sale_notes.resume'),
            onClick: () => this.$router.push({ name: 'sale_notes.resume', params: { key: this.$route.params.key } })
          },
        ]
      },
      delete() {
        return this.$axios.delete(`/sale_orders/${this.$route.params.key}`)
      },
      setModel() {
        this.$set(this, 'model', this.value)
      },
    }
  }
  </script>
  <style lang="scss" scoped>
  ::v-deep {
    .preloader-component {
      background-color: #FFFFFF;
    }
  }
  .container-title {
    margin-top: 10px;
    font-family: Lato;
    font-size: 12px;
    font-weight: 800;
    line-height: 14px;
    letter-spacing: 0.05em;
    text-align: left;
    margin-bottom: 8px;
    text-transform: uppercase;
  }
  .custom-group {
    margin-bottom: 30px;
  }
  .custom-label, .custom-text {
    font-family: Lato;
    font-size: 14px;

    line-height: 17px;
    letter-spacing: 0em;
    text-align: left;
  }
  .custom-label {
    font-weight: 700;
    color: #161B4D;
    text-transform: uppercase;
    margin-bottom: 10px ;
  }
  .custom-text {
    font-weight: 400;
  }
  .section-title {
    background-color: #F9FAFB;
    color: #161B4D;
    padding: 14px 21px;
    text-transform: uppercase;
    font-family: Lato;
    font-size: 14px;
    font-weight: 700;
    line-height: 17px;
    letter-spacing: 0.05em;
    text-align: left;
    border: 1px solid #ECECF2;
  }

  .section-title:first-of-type {
    border-top: none;
  }
  .section-body {
    padding: 14px 20px;
    .section-label, .section-value {
      font-family: Lato;
      font-size: 14px;
      line-height: 17px;
      letter-spacing: 0em;
      text-align: left;
    }
    .section-label {
      color: #161B4D;
      font-weight: 400;
    }
    .section-value {
      color: #161B4D;
      font-weight: 700;
      text-align: right;
    }

    .section-row {
      padding: 6px 0;
    }
  }

  .sale-item-thead {
    color: #161B4D;
    background-color: #F9FAFB;
    text-transform: uppercase;
    font-family: Lato;
    font-size: 14px;
    font-weight: 700;
    line-height: 17px;
    letter-spacing: 0.05em;
    text-align: left;
  }
  .sale-item-tbody {
    color: #161B4D;
    font-family: Lato;
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: left;
  }

  ::v-deep .page-content {
    background: #EEF3F7;
  }
  </style>